import { WALLET_TITLES } from '@/modules/account/constants'
import type { Wallet } from '@/modules/account/types'
import { cn } from '@/utils'
import { CreditBalance } from './CreditBalance'
import { CreditBundleSelector } from './CreditBundleSelector'

export function WalletSection({
  wallet,
  className,
}: {
  wallet: Wallet
  className?: string
}) {
  return (
    <section
      aria-labelledby={`${wallet}-wallet-heading`}
      className={cn('space-y-8', className)}
    >
      <h2
        id={`${wallet}-wallet-heading`}
        className="text-2xl font-semibold tracking-tight"
      >
        {WALLET_TITLES[wallet]}
      </h2>

      <CreditBalance wallet={wallet} />

      <CreditBundleSelector wallet={wallet} />
    </section>
  )
}
